import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-forestDeep text-mutedDark" data-id="element-88" data-mp="3gfsmscqd8umz">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-89" data-mp="3ggk7utmc79z0" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-90" data-mp="32ovxaurqktk5">
        <p className="font-display text-lg font-extrabold uppercase text-white" data-id="element-91" data-mp="36p6df098t0cq">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-92" data-mp="3ufa4k858v7mu">Created by wine education specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-lineDark pt-6 text-xs" data-id="element-93" data-mp="38h456i9zcjd">
          © 2026 {productShortName} — All rights reserved.
        </p>
      </div>
    </footer>;
}